<template>
  <div class="card">
    <header class="header-card">
      <p>
        {{ $t('produitSalon.dates.titre') }}
      </p>
    </header>
    <div class="card-content columns is-multiline">
      <div class="column is-4">
        <b-field :label="$t('produitSalon.dates.dateSignature')">
          <b-datepicker show-week-number
                        nearby-selectable-month-days
                        v-model="produit.dateSignature"
                        icon="calendar-today"
                        :editable="true">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-4 ">
        <b-field :label="$t('produitSalon.dates.dateDebut')" class="obligatoire">
          <b-datepicker show-week-number
                        nearby-selectable-month-days
                        v-model="produit.dateDebut"
                        icon="calendar-today"
                        :editable="true">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field :label="$t('produitSalon.dates.dateFin')">
          <b-datepicker show-week-number
                        nearby-selectable-month-days
                        v-model="produit.dateFin"
                        icon="calendar-today"
                        :editable="true">
          </b-datepicker>
        </b-field>
      </div>
      <div class="column is-4" v-if="produit.periodiciteId !== undefined">
        <b-field :label="$t('produitPresse.formatProduit.periodicite')">
          <b-select expanded v-model="produit.periodiciteId">
            <option :value="null"></option>
            <option v-for="periodicite in periodicites"
                    :key="periodicite.id"
                    :value="periodicite.id">
              {{ periodicite.libelle }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'CatalogueProduitGeneralPresseEditDates',
  props: {
    produit: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    periodicites() {
      return this.parametre(PARAMETRES_KEYS.periodicite);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.periodicite]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
